import {Box, Button, CircularProgress, Dialog, DialogTitle, Fab, Paper, TextField, Typography} from '@material-ui/core';
import {Dispatch, useState} from 'react';
import API from '../../../APIs/API';
type agent = {
    firstName: string;
    lastName: string;
    email: string;
};
type DeleteModalProps = {
    open: boolean;
    handleClose: () => void;
    load: Dispatch<any>;
    agent: agent;
};
export default function DeleteAgentModal(props: DeleteModalProps) {
    const {open, handleClose, load, agent} = props;
    const [confirmText, setConfirmText] = useState('');
    const [error, setError] = useState(false);
    const [progress, setProgress] = useState(false);
    const handleChange = (e: any) => {
        setConfirmText(e.target.value);
    };
    const deleteAgent = async () => {
        if (confirmText === agent.firstName) {
            setProgress(true);
            await API.Call('agents', 'DELETE', agent);
            setProgress(false);
            load((prev: any) => !prev);
            setError(false);
            handleClose();
        } else {
            setError(true);
        }
    };
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>SURE TO WANT TO DELETE AGENT ??</DialogTitle>
            <Box paddingLeft={3} marginBottom={3} width={'80%'}>
                <Typography>Please type '{agent.firstName}' to confirm delete</Typography>
            </Box>
            <Box paddingLeft={3} marginBottom={3} width={'80%'}>
                <TextField onChange={handleChange} error={error} fullWidth label="Enter first name" />
            </Box>
            {progress && <CircularProgress />}
            <Button color="primary" variant="contained" onClick={deleteAgent}>
                Delete
            </Button>
        </Dialog>
    );
}
